export enum CompanyEnum {
  INESALUD = 'inesalud',
  INESEM = 'inesem',
  EDUCA = 'educa',
  EDUSPORT = 'edusport',
  ENALDE = 'enalde',
  ESIBE = 'esibe',
  INEAF = 'ineaf',
  INNOVA = 'innova',
  REDEDUCA = 'rededuca',
  EDUCAOPENAI = 'educaopenai',
  MARKETPLACE = 'app'
}
